// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6ac50bb0","455":"2aba2e19","977":"280bfb51"}[chunkId] + ".chunk.js";
};